import React, { useRef } from 'react';
import UploadButton from '../UploadButton/UploadButton';

export default function AssetUpload({ fileKey, uploadedFiles, setUploadedFiles, currentFile, readOnly, description, icon, accept, onDeleteFileUpload }) {
  const uploadRef = useRef(null);

  const onFileInputChangeHandler = async (e) => {
    setUploadedFiles({ ...uploadedFiles, [fileKey]: e.target.files[0] });
  };

  const onDelete = async () => {
    onDeleteFileUpload(fileKey);
  }

  const uploadedFile = uploadedFiles[fileKey];

  return (
    <div className='d-sm-flex align-items-center'>
      <UploadButton
        description={description}
        icon={icon}
        disabled={readOnly}
        uploadedFile={uploadedFile}
        persistedFile={currentFile && currentFile.location}
        onClick={() => uploadRef.current.click()}
        onDelete={onDelete}
      />
      <input ref={uploadRef} type="file" name="file" onChange={onFileInputChangeHandler} accept={accept} className='d-none' />
    </div>
  )
}
